import { useQuery } from '@tanstack/react-query'
import { ExtendableQueryOptions } from 'shared/api/api.types'

import { hrApi } from '../..'
import { HrPosition } from '../../hrApi.types'
import { GetHrPositionsRaw } from './getHrPositions.types'

// The whole org's occupation list is small (~63 KB for 111 rows), so it's
// fetched once and filtered client-side rather than searched server-side.
export const getHrPositions = async (): Promise<HrPosition[]> => {
  const response = await hrApi.get<GetHrPositionsRaw>('/occupations')
  const rows = Array.isArray(response.data)
    ? response.data
    : (response.data.data ?? [])
  return rows.map(position => ({
    id: String(position.id),
    name: position.name,
    department_id: position.department_id
  }))
}

export const GET_HR_POSITIONS_QUERY_KEY = 'hr-positions'

export const useGetHrPositionsQuery = (
  options?: ExtendableQueryOptions<HrPosition[]>
) =>
  useQuery({
    queryKey: [GET_HR_POSITIONS_QUERY_KEY],
    queryFn: getHrPositions,
    // occupations barely change; avoid refetching on every panel open
    staleTime: 5 * 60 * 1000,
    ...options
  })
